// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import { Grid, Row, Col } from 'Common/Grid';
import styles from 'components/BrowseAll.scss';
import slugify from 'slugify';
import TagHtml from 'Common/TagHtml';
import isWindow from 'Common/isWindow';
import isWindowProp from 'Common/isWindowProp';
import scrollToTopOfPage from 'Common/scrollToTopOfPage';
import { gtmEventPush } from 'utils/gtm/events';

export default class BrowseAll extends PureComponent<*, *> {
  updatePage: (url: string) => void = url => {
    if (isWindow() && isWindowProp('location')) {
      this.props.history.push(url);
      scrollToTopOfPage();
    }
  };

  render(): Element<*> | null {
    const toUrl = str => slugify(str).toLowerCase();
    const make = this.props.make ? this.props.make : '';
    const makeUrl = this.props.make
      ? slugify(this.props.make.toLowerCase()) + '/'
      : '';
    const { classBrowseAll, classBrowseAllH1, classBrowseAllCell } = styles;

    if (!this.props.items || !this.props.items.length) {
      return null;
    }

    const thisPageData = this.props.thisPageData;
    let title =
      thisPageData.type === 'leasing'
        ? `Browse all ${make} leasing deals by make`
        : `Browse all ${thisPageData.type} ${make} ${this.props.text} for sale`;
    thisPageData.name === 'new-cars-in-stock' &&
      (title = `Browse all in stock ${make} cars for sale`);
    return (
      <div className={classBrowseAll}>
        <Grid>
          <Row>
            <Col colXs={12}>
              <TagHtml extendStyle={classBrowseAllH1} content={title} />
            </Col>
          </Row>
          <Row>
            {this.props.items.map((item, i) => {
              return (
                <Col key={i} colXs={6} colMd={4} className={classBrowseAllCell}>
                  <a
                    href={`/${thisPageData.name}/${makeUrl}${toUrl(item.key)}`}
                    data-bi="click"
                    data-section="browse-all-used-makes"
                    onClick={event => {
                      event.preventDefault();
                      gtmEventPush({
                        method: 'browseMakes',
                        args: {
                          makePrefix: make,
                          itemName: item.key
                        }
                      });
                      this.updatePage(
                        `/${thisPageData.name}/${makeUrl}${toUrl(item.key)}`
                      );
                    }}
                    key={i}
                  >
                    {`${
                      thisPageData.type !== 'new' ? thisPageData.shortName : ''
                    } ${make} ${item.key}`}
                  </a>
                </Col>
              );
            })}
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Common/BrowseAll/index.js